"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _app = _interopRequireDefault(require("firebase/app"));

require("firebase/auth");

var _actions = require("../../../redux/login/actions");

var _cookies = require("@devsontap/nica-api/core/utils/cookies");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * This component is intended to use ONCE in the Application
 * @param children  The component to render when the user is Authed
 * @param unAuthed  The component to render when the user is Unauthed
 */
var AuthProvider = function AuthProvider(_ref) {
  var children = _ref.children;
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    _app.default.auth().onAuthStateChanged( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(user) {
        var token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!user) {
                  _context.next = 8;
                  break;
                }

                _context.next = 3;
                return user.getIdTokenResult(true);

              case 3:
                token = _context.sent;
                // KBM - Create a session cookie that can be used for login in other domains
                dispatch((0, _actions.createSessionCookie)(token)); // console.log("claims", token.claims);

                dispatch((0, _actions.userAuthed)(token.claims));
                _context.next = 10;
                break;

              case 8:
                (0, _cookies.deleteSessionCookie)();
                dispatch((0, _actions.userUnauthed)());

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  }, [dispatch]);
  return children;
};

var _default = AuthProvider;
exports.default = _default;